<script>
import { mapState, mapActions } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
   components: {
      VueApexCharts,
   },
   data() {
      return {
         // Flag loading untuk menampilkan overlay spinner saat request berjalan.
         loading: false,
      }
   },
   computed: {
      ...mapState({
         nibResponse: state => state.DashboardOss.nibPerKecamatan,
         tahun: state => state.DashboardOss.tahun,
         refreshTimestamp: state => state.DashboardOss.refreshTimestamp,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      chartSeries() {
         return [{
            name: 'NIB Terbit',
            data: this.nibResponse.data.map(item => item.total),
         }]
      },
      chartOptions() {
         const textColor = this.isDark ? '#b4b7bd' : '#6e6b7b'

         return {
            chart: {
               type: 'bar',
               foreColor: textColor,
               toolbar: {
                  show: false,
               },
               fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
            },
            colors: ['#1d4ed8'],
            plotOptions: {
               bar: {
                  borderRadius: 4,
                  columnWidth: '45%',
               },
            },
            dataLabels: {
               enabled: false,
            },
            grid: {
               borderColor: this.isDark ? '#3b4253' : '#ebe9f1',
               strokeDashArray: 4,
            },
            xaxis: {
               categories: this.nibResponse.data.map(item => item.kecamatan),
               labels: {
                  rotate: -45,
                  style: {
                     colors: textColor,
                  },
               },
               title: {
                  text: 'Kecamatan',
                  style: {
                     color: textColor,
                  },
               },
            },
            yaxis: {
               min: 0,
               forceNiceScale: true,
               title: {
                  text: 'Jumlah NIB',
                  style: {
                     color: textColor,
                  },
               },
               labels: {
                  style: {
                     colors: [textColor],
                  },
                  formatter: value => Math.round(value),
               },
            },
            tooltip: {
               theme: this.isDark ? 'dark' : 'light',
               y: {
                  formatter: value => `${value} NIB`,
               },
            },
         }
      },
   },
   watch: {
      tahun(newYear, oldYear) {
         if (newYear !== oldYear) this.loadNibPerKecamatan(newYear)
      },
      refreshTimestamp() {
         this.loadNibPerKecamatan(this.tahun)
      },
   },
   mounted() {
      this.loadNibPerKecamatan(this.tahun)
   },
   methods: {
      ...mapActions({
         getNibPerKecamatan: 'DashboardOss/getNibPerKecamatan',
      }),
      async loadNibPerKecamatan(year) {
         this.loading = true
         try {
            await this.getNibPerKecamatan(year)
         } catch (error) {
            // Chart tetap menampilkan data kosong saat request gagal.
         } finally {
            this.loading = false
         }
      },
   },
}
</script>

<template>
   <b-overlay
      :show="loading"
      :variant="isDark ? 'dark' : 'white'"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
   >
      <b-row>
         <b-col cols="12">
            <b-card class="card-wrapper">
               <div class="d-flex justify-content-between align-items-center mb-1">
                  <div>
                     <h4 class="mb-25">
                        NIB Terbit per Kecamatan tahun {{ tahun }}
                     </h4>
                     <small class="text-muted">Periode {{ nibResponse.tahun }}</small>
                  </div>
               </div>
               <vue-apex-charts
                  type="bar"
                  height="350"
                  :options="chartOptions"
                  :series="chartSeries"
               />
            </b-card>
         </b-col>
      </b-row>
   </b-overlay>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}
</style>
